/*
 * *****************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Fri, Jul 23rd 2021, 8:46:27 pm
 *
 * *****************************************************
 */

import styled from 'styled-components';

export const RetryText = styled.div`
  width: 100%;
  margin-bottom: 11rem;
  margin-top: 8rem !important;
  text-align: center;
`;
